var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.5C7.07031 0.5 7.75 1.17969 7.75 2V8.75C7.75 10.8359 6.0625 12.5 4 12.5C1.91406 12.5 0.25 10.8359 0.25 8.75V2C0.25 1.17969 0.90625 0.5 1.75 0.5H6.25ZM4 8C3.36719 8 2.875 8.51562 2.875 9.125C2.875 9.75781 3.36719 10.25 4 10.25C4.60938 10.25 5.125 9.75781 5.125 9.125C5.125 8.51562 4.60938 8 4 8ZM4 7.25C4.60938 7.25 5.125 6.75781 5.125 6.125C5.125 5.51562 4.60938 5 4 5C3.36719 5 2.875 5.51562 2.875 6.125C2.875 6.75781 3.36719 7.25 4 7.25ZM4 2C3.36719 2 2.875 2.51562 2.875 3.125C2.875 3.75781 3.36719 4.25 4 4.25C4.60938 4.25 5.125 3.75781 5.125 3.125C5.125 2.51562 4.60938 2 4 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintenance);
export default __webpack_public_path__ + "static/media/IconMaintenance.fcab747b1cf6a7f4c546954cdfe40701.svg";
export { ForwardRef as ReactComponent };